import React, { useEffect, useState } from 'react';
import PopulationCharts from './PopulationCharts';
import {
    ModalOverlay,
    ModalContent,
    CloseButton,
    ModalTitle,
    TabContainer,
    TabList,
    Tab,
    TabContent,
    ModalHeader,
} from './style';
import useDragAndDrop from '../../hooks/useDragAndDrop';
import axios from 'axios';
import { API_URL } from 'config/URL/URL';
const PopulationChartModal = ({ isOpen, onClose, location }) => {
    const [ activeTab, setActiveTab ] = useState('growth');
    const [ apiData, setApiData ] = useState();
    
    const { modalRef, position, isVisible, handleDragStart } = useDragAndDrop(isOpen && apiData);

    useEffect(() => {
        if(isOpen && location) {
            fetchApiData(location.hjdCd);
        }
        
        return () => {
            setActiveTab('growth');
            setApiData();
        }
    }, [isOpen, location])


    if(!isOpen) return null;

    const fetchApiData = async (hjdCd) => {
        const newData = await getPopDetailData(hjdCd);
        setApiData(newData);
    }

    const getPopDetailData = async (hjdCd) => {
        const options = {
            params: {
                hjd_cd: hjdCd
            }
        }

        try {
            // const response = await axios.get(`${API_URL}/pop/getPopInfoByHjdCd`, options);
            const response = await axios.get(`${API_URL}/pop/getPopInfoByHjdCd`, options);
            
            return response.data;
        } catch(error) {
            console.log(error);
        }
    }

    // 데이터 변환 함수
    const transformData = (apiData) => {
        if (!apiData || !apiData.popList || !apiData.popList.length) {
            return null;
        }

        const popRate = apiData.popRate || {};

        // 지역명 배열 추출
        const locationNames = apiData.popList.map((item) => item.hjdNm);

        // 인구 증감률 데이터 변환 (population : popList 첫번째 데이터, growthRate : popRate)
        const growthData = {
            population: [
                apiData.popList[0].pop_0_9_cnt || 0,
                apiData.popList[0].pop_10_19_cnt || 0,
                apiData.popList[0].pop_20_29_cnt || 0,
                apiData.popList[0].pop_30_39_cnt || 0,
                apiData.popList[0].pop_40_49_cnt || 0,
                apiData.popList[0].pop_50_59_cnt || 0,
                apiData.popList[0].pop_60_up_cnt || 0,
            ],
            growthRate: [
                popRate.pop_0_9_rate || 0,
                popRate.pop_10_19_rate || 0,
                popRate.pop_20_29_rate || 0,
                popRate.pop_30_39_rate || 0,
                popRate.pop_40_49_rate || 0,
                popRate.pop_50_59_rate || 0,
                popRate.pop_60_up_rate || 0,
            ],
        };

        // 연령대별 점유율 데이터 변환 (popList)
        const shareData = {
            age0to9: apiData.popList.map((item) => (item.pop_0_9_share || 0) * 100),
            age10to19: apiData.popList.map((item) => (item.pop_10_19_share || 0) * 100),
            age20to29: apiData.popList.map((item) => (item.pop_20_29_share || 0) * 100),
            age30to39: apiData.popList.map((item) => (item.pop_30_39_share || 0) * 100),
            age40to49: apiData.popList.map((item) => (item.pop_40_49_share || 0) * 100),
            age50to59: apiData.popList.map((item) => (item.pop_50_59_share || 0) * 100),
            age60plus: apiData.popList.map((item) => (item.pop_60_up_share || 0) * 100),
        };

        return { growthData, shareData, locationNames };
    };

    // 데이터 변환
    const transformedData = transformData(apiData);

    // 변환된 데이터 또는 기본 데이터 사용
    const finalGrowthData = transformedData?.growthData;
    const finalShareData = transformedData?.shareData;
    const locationNames = transformedData?.locationNames || [];

    return (
        <ModalOverlay onClick={onClose}>
            <ModalContent
                ref={modalRef}
                style={{
                    left: position.x,
                    top: position.y,
                    opacity: isVisible ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: isVisible ? 'auto' : 'none',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <ModalHeader onMouseDown={handleDragStart} onTouchStart={handleDragStart}>
                    <ModalTitle>{location?.hjdNm} 통계</ModalTitle>
                    <CloseButton
                        onClick={onClose}
                        onMouseDown={(e) => e.stopPropagation()}
                        onTouchStart={(e) => e.stopPropagation()}
                    >
                        &times;
                    </CloseButton>
                </ModalHeader>

                <TabContainer>
                    <TabList>
                        <Tab className={activeTab === 'growth' ? 'active' : ''} onClick={() => setActiveTab('growth')}>
                            인구 증감률
                        </Tab>
                        <Tab className={activeTab === 'share' ? 'active' : ''} onClick={() => setActiveTab('share')}>
                            연령대별 점유율
                        </Tab>
                    </TabList>

                    <TabContent active={activeTab === 'growth'}>
                        <PopulationCharts
                            growthData={finalGrowthData}
                            growthTitle={`${location?.hjdNm} 연령대별 인구 및 증감률`}
                            locationNames={locationNames}
                        />

                    </TabContent>

                    <TabContent active={activeTab === 'share'}>
                        <PopulationCharts
                            shareData={finalShareData}
                            shareTitle={`${location?.hjdNm} 연령대별 인구수 점유율`}
                            locationNames={locationNames}
                        />

                    </TabContent>
                </TabContainer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default PopulationChartModal;
